import { defineComponent as _defineComponent } from 'vue'
import mitt from 'mitt'
import axios from 'axios'
import { useRouter, useStore, computed, useContext, onMounted, ref } from '@nuxtjs/composition-api'
// import { changelogStore, CHANGELOG_BASE_URL, CHANGELOG_ENTRY_DETAIL, CHANGELOG_LIST } from '~/pstore/changelog'
import useRoleManagement from '~/composeables/roleManagement/roleManagement'
import useSetupLanguage from '~/composeables/setupLanguage/setupLanguage'
import useUpsellContentScreen from '~/composeables/upsellContentScreen/upsellContentScreen'
import useUserStuff from '~/composeables/userStuff/userStuff'
import useShoppingLink from '~/composeables/shoppingLink/shoppingLink'
import { debugEcho } from '~/utils/debugTools'
// const { i18n, $apiClient } = useContext()
interface IClickLink {
  action: string
  id: string
  path?: string
  url?: string
  target?: string
  destination: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const store = useStore()
const router = useRouter()
// const clStore = changelogStore()

window.mitt = window.mitt || mitt()

const { newAppHeaderModel, realPartnerType, trialOrNotTrialPlan } = useRoleManagement()
const { combinedName } = useUserStuff()

const configuration = ref<any>(null)

const injectLocaleConfig = () => {
  configuration.value = {
      flags: JSON.stringify({
        company: false,
        documentation: {
          changelog: false,
          documentation: false
        },
        user: {
          apiKeys: {
            label: 'icon',
            event: 'upsell'
          },
          licenseManagement: false
        },
        navigation: {
          fullSiteCheck: {
            label: 'icon',
            event: 'upsell'
          },
          metrics: {
            label: 'icon',
            event: 'upsell'
          },
          blocklists: {
            label: 'icon',
            event: 'upsell'
          }
        }
      }),
      userDetails: JSON.stringify({
        avatar: 'https://s.gravatar.com/avatar/9cce24eb52829eba44d58e4b74393869?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fsa.png',
        email: 'sascha.fuchs+1@webpros.com',
        name: 'sascha.fuchs+1@webpros.com',
        plan: 'Lite Custom No Alerts',
        features: [
          {
            name: 'servers',
            current: 0,
            max: 1,
            threshold: 1
          },
          {
            name: 'websites',
            current: 1,
            max: 5,
            threshold: 5
          },
          {
            name: 'blocklistIpChecks',
            current: 2048,
            max: 0,
            threshold: 0
          }
        ]
      }),
      logoSrc: 'http://app.stage.360monitoring.com/img/360monitoring.svg',
      logoPath: '/',
      changelogUrls: JSON.stringify({
        changelogUrl: 'https://docs.360monitoring.com/changelog',
        getChangelogs: '//app.stage.360monitoring.com/changelog/last',
        postChangelog: '//app.stage.360monitoring.com/changelog/read/'
      }),
      showChangelogIcon: true,
      localeEndpoint: ''
    }
}

const loadGravatar = () => {
  store.dispatch('access/setGravatar', JSON.parse(configuration.value.userDetails)['avatar'])
}

const setupConfig = async () => {
  if (process.env.NODE_ENV === 'development') {
    injectLocaleConfig()
    loadGravatar()
  } else {
    try {
      const { data: { data } } = await axios.get('/templating/get-app-header-configuration')
      if (Object.keys(data).length === 0) {
        injectLocaleConfig()
        loadGravatar()
        return
      }
      configuration.value = {
        flags: JSON.stringify(data.flags),
        userDetails: JSON.stringify(data.userDetails),
        logoSrc: data.logoSrc,
        logoPath: data.logoPath,
        changelogUrls: JSON.stringify(data.changelogUrls),
        showChangelogUpdates: data.showChangelogIcon,
        localeEndpoint: data.localeEndpoint
      }
      loadGravatar()
    } catch (e) {
      console.error('Error fetching external config', e)
    }
  }
}

onMounted(() => {
  setupConfig()
})

// const generateFlag = computed(() => {
//   const plan = trialOrNotTrialPlan.value

//   const conditionBusiness = ['lite', 'trial', 'pro'].includes(plan)
//   const conditionPro = ['lite', 'trial'].includes(plan)
//   const conditionTrial = ['lite'].includes(plan)

//   const navBlocklistDefault = {
//     label: conditionPro && 'icon'
//     // event: conditionPro && 'upsell'
//   }

//   const userApiKeysDefault = {
//     label: conditionBusiness && 'icon',
//     event: conditionBusiness && 'upsell'
//   }

//   const navFullSiteCheckDefault = {
//     label: conditionPro && 'icon',
//     event: conditionPro && 'upsell'
//   }

//   const navMetricsDefault = {
//     label: conditionTrial && 'icon',
//     event: conditionTrial && 'upsell'
//   }

//   const navDefault = {
//     fullSiteCheck: navFullSiteCheckDefault,
//     metrics: navMetricsDefault,
//     blocklists: navBlocklistDefault
//   }

//   const flags = {
//     partner: {
//       documentation: {
//         changelog: false,
//         documentation: false
//       },
//       user: {
//         apiKeys: userApiKeysDefault,
//         licenseManagement: false
//       },
//       company: false,
//       navigation: navDefault
//     },
//     platform: {
//       user: {
//         apiKeys: userApiKeysDefault,
//         licenseManagement: false
//       },
//       navigation: navDefault
//     },
//     threesixty: {
//       user: {
//         apiKeys: userApiKeysDefault,
//         licenseManagement: false
//       },
//       navigation: navDefault
//     },
//     standalone: {
//       user: {
//         apiKeys: userApiKeysDefault
//       },
//       company: false,
//       navigation: navDefault
//     }
//   }

//   return JSON.stringify(flags[newAppHeaderModel.value] || flags['platform'])
// })

// const getUserPlan = computed(() => store.getters['access/getUserPlan'])
// const userDetails = computed(() => store.getters['access/getUserDetails'])
// const status = computed(() => store.getters['monitoringStatusStore/getStatus'])

const { generateStoreLink } = useShoppingLink()

// const defineUser = computed(() => {
//   return JSON.stringify({
//     avatar: userDetails.value.gravatar,
//     email: userDetails.value.email,
//     name: combinedName.value,
//     plan: i18n.t(`planName-${getUserPlan.value}`),
//     features: [
//       {
//         name: 'servers',
//         current: status.value?.websites?.used || '0',
//         max: status.value?.websites?.allowed || '0',
//         threshold: 101
//       },
//       {
//         name: 'websites',
//         current: status.value?.servers?.used || '0',
//         max: status.value?.servers?.allowed || '0',
//         threshold: 101
//       },
//       {
//         name: 'blocklistIpChecks',
//         current: 1700,
//         max: 10000,
//         threshold: 9000
//       }
//     ]
//   })
// })

// const changelogUrls = JSON.stringify({
//   changelogUrl: CHANGELOG_BASE_URL,
//   getChangelogs: CHANGELOG_LIST,
//   postChangelog: CHANGELOG_ENTRY_DETAIL
// })

const whitelabelConfig = computed(() => store.getters['whitelabel/getConfig'])

// const logoDetails = computed(() => {
//   return {
//     src: whitelabelConfig.value.logoUrl,
//     url: '/'
//   }
// })

const partnerType = computed(() => whitelabelConfig.value.partnerType)
const shouldHideUpdates = computed(() => ['partner'].includes(partnerType.value))
// const localeEndpoint = computed(() => {
//   if (['standalonePartner', 'partner'].includes(partnerType.value)) return ''
//   return process.env.NODE_ENV === 'production'
//     ? 'https://platform360.io/api/v1/accounts/user/locale'
//     : 'https://platform360.staging.plesk.tech/api/v1/accounts/user/locale'
// })

const { changeLanguage } = useSetupLanguage()
const { triggerUpsellContent, triggerCleverbridgeContent } = useUpsellContentScreen()

const clickLogo = () => {
  window.location.href = ['standalonePartner', 'standaloneRetail', 'partner'].includes(realPartnerType.value)
    ? window.location.origin
    : 'https://monitoring.platform360.io/'
}

const logoutUser = () => {
  if (process.env.NODE_ENV === 'production') {
    store.dispatch('access/logoutClear')
    setTimeout(() => {
      window.location.href = whitelabelConfig.value.partnerType === 'platform'
        ? 'https://platform360.io/auth/logout'
        : `${window.location.origin}/signout`
    }, 100)
  } else {
    store.dispatch('access/logoutUser')
    location.reload()
  }
}

const featureStoreLink = async () => {
  const link = await generateStoreLink()
  // window.open(link, '_blank')
 // triggerCleverbridgeContent()
}

const clickLink = (details: IClickLink) => {
  if (details.id.startsWith('feature-')) {
    featureStoreLink()
    return
  }
  if (details.id === 'logout') {
    logoutUser()
    return
  }
  if (details.url) {
    window.open(details.url, details.target || '_self')
  } else if (details.path) {
    if (details.destination === 'external') {
      window.location.href = `${window.location.origin}${details.path}`
    } else {
      router.push(details.path.replace('/sitecheck', ''))
    }
  }
}

window.mitt.on('tsxAppHeader', (payload) => {
  debugEcho('payload', payload)
  switch (payload.action) {
    case 'click':
      clickLink(payload)
      break
    case 'setLanguage':
      changeLanguage(payload.code)
      break
    case 'openContentScreen':
      triggerUpsellContent(payload.contentId, payload.label, payload.title)
      break
    case 'clickLogo':
      clickLogo()
      break
  }
})


return { __sfc: true,store, router, newAppHeaderModel, realPartnerType, trialOrNotTrialPlan, combinedName, configuration, injectLocaleConfig, loadGravatar, setupConfig, generateStoreLink, whitelabelConfig, partnerType, shouldHideUpdates, changeLanguage, triggerUpsellContent, triggerCleverbridgeContent, clickLogo, logoutUser, featureStoreLink, clickLink }
}

})